import type { RenderLeafProps } from 'slate-react';

import style from './leaf.module.scss';

export const Leaf = ({ attributes, children, leaf }: Omit<RenderLeafProps, 'text'>) => {
  let leafChildren = children;

  if (leaf.bold) leafChildren = <strong>{leafChildren}</strong>;
  if (leaf.italic) leafChildren = <em>{leafChildren}</em>;
  if (leaf.underline) leafChildren = <u>{leafChildren}</u>;
  if (leaf.strikethrough) leafChildren = <s>{leafChildren}</s>;

  return (
    <span
      {...attributes}
      className={style.Leaf}
    >
      {leafChildren}
    </span>
  );
};
